var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeScoreIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1052_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.30079 3.1534L5.22084 4.09743L4.16141 5.18443L3.22618 4.22487C1.98442 5.70861 1.23396 7.63794 1.23396 9.74714H0C0 7.0557 1.06337 4.61887 2.78254 2.85493C4.50178 1.09104 6.87678 0 9.50004 0C11.5579 0 13.4631 0.671565 15.0187 1.81263L14.0286 2.65093C12.9243 1.90763 11.6361 1.4283 10.2492 1.30049V2.40721H8.7508V1.30049C7.07253 1.45522 5.53883 2.1245 4.30079 3.1534ZM8.65851 8.40926C7.21477 9.63307 9.14575 11.693 10.4486 9.93942L16.3347 2.4034L16.0592 2.1435L8.65851 8.40926ZM16.7177 3.40949C18.1404 5.11361 19 7.32744 19 9.74714H17.766C17.766 7.72807 17.0784 5.87378 15.9303 4.41745L16.7177 3.40949Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1052_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 10.6176,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeScoreIco);
export default __webpack_public_path__ + "static/media/change-score-ico.789cf8f6b856688aec9f66a7ccc8ec6a.svg";
export { ForwardRef as ReactComponent };